import { defineStore } from 'pinia'
import {userInfo} from '@/api/login'
export const useCounterStore = defineStore({
  id: 'counter',
  state: () => ({
    WxFlage:true,
    copywriting:true,
    codeTime:60,
    codeTimeFlag:true,
    codeTime1:60,
    codeTimeFlag1:true,
    active:'flower',
    scrollTop:0,
    userInfo:{},
    appInfo:{},
    imgParmas:{},
    offsetHeight:0,
    register:false,
    generate:true,
    styleList:[],
    undateFlag:false,
    appStyleList: [],
    quitStyleTabs:'',
    appName:'1',
    createFlag:false,
    imgDate:{},
    sginFlag:true,
    isSafari:/Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)
  }),
  actions: {
    getWxFlag(){
      const ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){ 
        this.WxFlage = true
      } else{
        this.WxFlage = false
      }
    },
    copywritingTrue(){
      this.copywriting = true
    },
    copywritingFalse(){
      this.copywriting = false
    },
    codeTimeFunction(){
      const time = setInterval(()=>{
        this.codeTime--
        this.codeTimeFlag = false
        if (this.codeTime === 0) {
          clearInterval(time)
          this.codeTimeFlag = true
          this.codeTime = 60
        }
      },1000)
    },
    codeTimeFunction1(){
      const time = setInterval(()=>{
        this.codeTime1--
        this.codeTimeFlag1 = false
        if (this.codeTime1 === 0) {
          clearInterval(time)
          this.codeTimeFlag1 = true
          this.codeTime1 = 60
        }
      },1000)
    },
    setActive(e){
      this.active = e
    },
    setScrollTop(e){
      this.scrollTop = e
    },
    setUserInfo(e){
      this.userInfo = e
    },
    setAppInfo(e){
      this.appInfo = e
    },
    setImgParmas(e){
      this.imgParmas = e
    },
    setOffsetHeight(e){
      document.documentElement.style.setProperty('--textHeader', `${e}px`); 
    },
    setRegister(e){
      this.register = e
    },
    getUserinfo(e){
      userInfo({user_id:e}).then(res=>{
        if (res.data.nickname === '') {
          this.register = true
        }
        console.log(this.userInfo.id,res.data.id);
        if (res.data.id !== this.userInfo.id) {
          this.undateFlag = true
        }
        this.setUserInfo(res.data)
        localStorage.setItem('userInfo',JSON.stringify(res.data))
      })
    },
    setGenerate(e) {
      this.generate = e
    },
    setStyleList(e) {
      this.styleList = e
      this.quitStyleTabs = e[0].opt_style
      if (e[0].opt_style === "style") {
        this.appStyleList = [
          {
            name: e[0].opt_style,
            ...e[0].list[0],
          },
        ];
      }
    },
    clearParmas(){
      this.appStyleList = []
      this.styleList = []
      this.quitStyleTabs = ''

    },
    setQuitStyleTabs(e) {
      this.quitStyleTabs = e
    },
    setQuitStyle(e) {
      const nameFlag = this.appStyleList.find(
        (item) => item.name === this.quitStyleTabs
      );
      if (nameFlag) {
        for (let i in e) {
          nameFlag[i] = e[i];
        }
      } else {
        this.appStyleList.push({
          name: this.quitStyleTabs,
          ...e,
        });
      }
    },
    setEditData(e) {
      this.appStyleList = e
      console.log(this.appStyleList);
    },
    clearAppStyleList() {
      this.appStyleList = []
    },
    setCreateFlag(e) {
      this.createFlag = e
    },
    setSginFlag(e) {
      this.sginFlag = e
    },
    setUndateFlag(e){
      this.undateFlag = e
    },
    setImgDate(e){
      this.imgDate = e
    }
  }
})
